import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ProgramDetail.css';

const FoodDetail = () => {
    useScrollAnimation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/programs');
    };

    return (
        <div className="program-detail-page">
            <div className="program-hero">
                <div className="container">
                    <button onClick={handleBackClick} className="back-link">
                        <i className="fas fa-arrow-left"></i> Back to Programs
                    </button>
                    <div className="program-hero-content">
                        <div className="program-icon-hero">
                            <i className="fas fa-bowl-rice"></i>
                        </div>
                        <h1>Food Program</h1>
                        <p className="program-tagline">Serving food with love and dignity to elders and needy children</p>
                    </div>
                </div>
            </div>

            <div className="program-content">
                <div className="container">
                    <section className="program-section scroll-animate">
                        <h2>Our Food Programs</h2>
                        <p>We run two dedicated food distribution programs serving different segments of our community with nutritious meals, love, and dignity.</p>
                    </section>

                    <div className="food-schemes-grid scroll-animate">
                        <div className="food-scheme-card" onClick={() => navigate('/programs/food/elders')}>
                            <div className="scheme-icon">
                                <i className="fas fa-hands-holding-heart"></i>
                            </div>
                            <h2>Engal Thatha Engal Patti Annadhana Scheme</h2>
                            <p className="scheme-description">Serving nutritious meals to elders with love, dignity, and respect</p>
                            <div className="scheme-stats">
                                <div className="stat">
                                    <i className="fas fa-users"></i>
                                    <span>300+ Elders</span>
                                </div>
                                <div className="stat">
                                    <i className="fas fa-utensils"></i>
                                    <span>Daily Lunch & Dinner</span>
                                </div>
                            </div>
                            <div className="scheme-cta">
                                Learn More <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>

                        <div className="food-scheme-card" onClick={() => navigate('/programs/food/students')}>
                            <div className="scheme-icon">
                                <i className="fas fa-graduation-cap"></i>
                            </div>
                            <h2>Engal Maanavar Annadhana Scheme</h2>
                            <p className="scheme-description">Providing daily nutritious dinner to needy students</p>
                            <div className="scheme-stats">
                                <div className="stat">
                                    <i className="fas fa-child"></i>
                                    <span>70+ Students</span>
                                </div>
                                <div className="stat">
                                    <i className="fas fa-bowl-food"></i>
                                    <span>Daily Dinner</span>
                                </div>
                            </div>
                            <div className="scheme-cta">
                                Learn More <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>
                    </div>

                    <section className="program-section scroll-animate">
                        <h2>About Our Food Program</h2>
                        <p>Our food program serves nutritious meals to elders and needy children with love, dignity, and respect. We believe that no one should go to bed hungry, and every meal should be served with care and compassion.</p>
                        <p>We focus on providing not just food, but also a sense of community and belonging. Our program ensures that vulnerable members of society receive fresh, hot meals prepared with attention to nutritional value and hygiene.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>About Our Food Program</h2>
                        <p>Our food program serves nutritious meals to elders and needy children with love, dignity, and respect. We believe that no one should go to bed hungry, and every meal should be served with care and compassion.</p>
                        <p>We focus on providing not just food, but also a sense of community and belonging. Our program ensures that vulnerable members of society receive fresh, hot meals prepared with attention to nutritional value and hygiene.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Key Achievements</h2>
                        <div className="achievements-grid">
                            <div className="achievement-card">
                                <div className="achievement-number">300+</div>
                                <div className="achievement-label">Elders Served Daily</div>
                                <p>Lunch and dinner provided with dignity</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">70+</div>
                                <div className="achievement-label">Students Fed Daily</div>
                                <p>Nutritious dinner for needy children</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">730+</div>
                                <div className="achievement-label">Meals Per Day</div>
                                <p>Continuous community support</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-cta scroll-animate">
                        <h2>Support Our Food Program</h2>
                        <p>Your donation can help us serve more meals and reach more people in need</p>
                        <div className="cta-buttons">
                            <button onClick={() => navigate('/donate')} className="btn btn-primary btn-large">Donate Now</button>
                            <button onClick={() => navigate('/contact')} className="btn btn-secondary btn-large">Volunteer with Us</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default FoodDetail;
